import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Component
import Accounts from './Accounts';
import Loader from '../Loader';

// Locale
import messages from '../../locale/jsonMessages';
import { withQuery } from '../../hoc/withGraphql';
import { getUserVerifiedInfoQuery } from '../../lib/graphql';

import cs from '../../components/commonStyle.css';
import s from './VerifiedInfo.css';

const VerifiedInfo = (props) => {
  const {
    intl: { formatMessage },
    verifiedInfoData: { loading, getUserVerifiedInfo } = {},
    account = { userId: null },
    userId,
    isTrustVerfiedPage,
    isUser
  } = props;

  const isLoggedInUser = account?.userId === userId;

  const template = (content) => (
    <div className={s.infoPadding}>
      <h5 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom3)}>
        {formatMessage(messages.verifiedInfo)}
      </h5>
      {content}
    </div>
  );

  if (loading) {
    return template(<Loader type={"text"} />);
  }

  return template(
    <Accounts
      items={getUserVerifiedInfo}
      isLoggedInUser={isLoggedInUser}
      isTrustVerfiedPage={isTrustVerfiedPage}
      isUser={isUser}
    />
  );
};

VerifiedInfo.propTypes = {
  intl: PropTypes.object.isRequired,
  verifiedInfoData: PropTypes.shape({
    loading: PropTypes.bool,
    getUserVerifiedInfo: PropTypes.object,
  }),
  userId: PropTypes.string,
  account: PropTypes.shape({
    userId: PropTypes.string.isRequired,
  }),
  isTrustVerfiedPage: PropTypes.bool,
  isUser: PropTypes.bool,
};

VerifiedInfo.defaultProps = {
  verifiedInfoData: {
    loading: true
  },
  account: {
    userId: null
  }
};

const mapState = (state) => ({
  account: state.account.data,
});

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState),
  withQuery(getUserVerifiedInfoQuery, {
    name: 'verifiedInfoData',
    options: (props) => ({
      variables: {
        userId: props.userId,
      },
      ssr: false,
      fetchPolicy: 'network-only'
    })
  })
)(VerifiedInfo);
